<template>
    <div>
        <div class="tarjetasIndividual shadow-sm mb-5" v-for="(edif, i) in edificios" :key="i">
            <vs-row class="pb-3" style="cursor: pointer;">
                <vs-col w="10">
                    <h5 class="mb-0" @click="toggleEdificios(i)"><i :class="aulas[i] == false ? 'far fa-caret-square-down' : 'far fa-caret-square-up'" class="mr-2"></i>  {{edif.nombre}} - <i></i>{{edif.clave}}</h5>
                </vs-col>
                <vs-col w="2" class="text-center">
                    <span>TIPO: </span><md-chip class="mini-chip col-blue text-uppercase" ><strong>{{edif.tipo}}</strong></md-chip>
                </vs-col>
            </vs-row>
            <md-divider></md-divider>
            <vs-row class="mt-3" v-show="aulas[i]" :key="componentKey">
                <vs-col sm="6" lg="3" v-for="(aula, j) in edif.aulas" :key="j">
                    <div class="estiloTarjeta" :class="'colorTarjeta' + i">
                        <div class="d-flex justify-content-between align-items-end mb-2">
                            <div class="d-flex">
                                <p class="mb-0"><small>OCUPACIÓN TOTAL: </small></p>
                                <p class="mb-0" style="font-size: 1rem"><strong>{{aula.ocupacion_total}}</strong></p>
                            </div>
                            <p class="text-right mb-0"><strong><i style="font-size: 20px;" class="far fa-building"></i></strong></p>
                        </div>
                        <div>
                            <small>AULA</small>
                            <p class="mb-3" style="font-size: 1rem"><strong>{{aula.nombre}}</strong></p>
                        </div>
                        <md-divider></md-divider>
                        <vs-row class="text-center mt-3">
                            <vs-col w="6">
                                <h6 class="mb-0"><strong>{{aula.capacidad}}</strong></h6>
                                <p class="mb-0"><small>CAPACIDAD</small></p>
                            </vs-col>
                            <vs-col w="6">
                                <h6 class="mb-0"><strong>{{aula.piso}}</strong></h6>
                                <p class="mb-0"><small>PISO</small></p>
                            </vs-col>
                        </vs-row>
                    </div>
                </vs-col>
            </vs-row>
        </div>  
    </div>
</template>

<script>
export default {
    props: [
        'edificios'
    ],
    data(){
        return{
            aulas: [],
            componentKey: 8
        }
    },
    created(){
        this.getAulas()
    },
    methods:{
        getAulas(){
            let result = []
            this.edificios.forEach(element => {
                result.push(true)
            });
            this.aulas = result
        },
        toggleEdificios(index){
            this.aulas[index] = !this.aulas[index]
            this.componentKey += 1
        }
    },
    watch:{
        edificios(){
            this.getAulas()
        }
    }
}
</script>

<style scoped>
.tarjetasIndividual{
    border: 1px solid #dee2e6;
    border-radius: 10px;
    padding: 20px;
}

.col-blue{
    color: #2874A6;
    background: rgb(214, 234, 248);
}
.estiloTarjeta{
    border-radius: 15px;
    color: black;
    border-radius: 10px;
    margin: 10px;
    padding: 20px 15px;
}
.colorTarjeta0{
    background: #B4DAC2;
}

.colorTarjeta1{
    background: #A1BCE8;
}

.colorTarjeta2{
    background: #FBCCAA;
}

.colorTarjeta3{
    background: #D7BDE2;
}

.colorTarjeta4{
    background: #A9CCE3;
}


</style>